import { Component, Input } from '@angular/core';
import { BaseComponent } from '../common/baseComponent/base.component';
import { ErrorForm } from './form.objects';

@Component({
  selector: 'plyca-validation-result',
  templateUrl: 'validationResult.template.html'
})
export class ValidationResultComponent extends BaseComponent {

  @Input()
  errorForm: ErrorForm;

  ngOnDestroy(): void {
    this.errorForm = null;
    super.ngOnDestroy();
  }

}
